/** @format */
import Filter from '../../interfaces/forms/Filter';

const _ = require('underscore');

export class FilterManager {
    private element: Array<string>;

    constructor() {
        this.element = [];
    }

    manageElement = (elementName: string, insertValue: boolean): void => {
        const exist = _.contains(this.element, elementName);
        if (insertValue) {
            if (!exist) {
                this.element.push(elementName);
            }
        } else {
            if (exist) {
                this.element = _.without(this.element, elementName);
            }
        }
    };

    hasManageElement = (): boolean => {
        return this.element.length > 0;
    };
}

export const getNewFilterArr = (filters: Array<Filter>, key: string, value: string, rawValue: Array<any> | null): Array<Filter> => {
    console.log(filters, key, value, rawValue);
    const newFilters: Array<Filter> = [];
    filters.map((el) => {
        if (el.name !== key) {
            if (Array.isArray(el.value)) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                if (!el.value.includes(value)) {
                    newFilters.push(el);
                }
            } else {
                if (el.value !== value) {
                    newFilters.push(el);
                }
            }
        } else {
            if (Array.isArray(el.value) && rawValue) {
                el.value = rawValue;
                newFilters.push(el);
            }
        }
    });
    return newFilters;
};
